export const nav_carbon = "Carbon";
export const nav_builds = "Builds";
export const nav_atelier = "Atelier";
export const nav_models = "Modelos";
export const nav_process = "Proceso";
export const nav_contact = "Contacto";
export const nav_about = "Acerca de";
export const nav_cta = "Inicia Tu Build";

export const hero_tagline = "Fabricado en Carbono. Construido Sin Compromisos.";
export const hero_cta_primary = "Configura el Tuyo";
export const hero_cta_secondary = "Explorar Modelos";
export const hero_scroll = "Desplázate para Descubrir";
export const hero_video_toggle = "Video";
export const hero_slides_toggle = "Diapositivas";
export const hero_mute = "Silenciar";
export const hero_unmute = "Activar Sonido";

export const manifest_title = "El Manifiesto Veragua";
export const manifest_text = "Diseñamos más allá de las convenciones. Cada componente es escrutado, cada superficie refinada. La fibra de carbono no es una elección de material—es nuestra base. El rendimiento no es una característica—es nuestra obsesión. No seguimos tendencias. Establecemos estándares.";
export const manifest_line1 = "Esto no es estilismo.";
export const manifest_line2 = "Esto es reconstrucción.";
export const manifest_line3 = "Escaneado en 3D. Diseñado. Acabado a mano.";

export const carbon_title = "División Carbon";
export const carbon_subtitle = "Excelencia en Ingeniería";
export const carbon_desc = "Nuestra División Carbon representa la cúspide de la ingeniería ligera. Cada componente está meticulosamente fabricado con fibra de carbono de grado aeroespacial, reduciendo el peso mientras maximiza la integridad estructural y el rendimiento.";
export const carbon_cta = "Explorar Tecnología Carbon";
export const carbon_division_label = "DIVISIÓN 01";
export const carbon_division_title1 = "CARBON";
export const carbon_division_title2 = "DIVISION";
export const carbon_division_desc = "Cada componente se desarrolla desde el compuesto en bruto hasta la pieza terminada internamente. Sin subcontratación. Sin compromiso.";
export const carbon_custom_config = "Configuraciones personalizadas disponibles para todas las plataformas.";
export const carbon_request_build = "SOLICITAR BUILD PERSONALIZADO";
export const carbon_view_details = "VER DETALLES";
export const carbon_materials_label = "MATERIALES";
export const carbon_process_label = "PROCESO";

export const builds_title = "Builds Signature";
export const builds_subtitle = "Obras Maestras en Movimiento";
export const builds_view = "Ver Build";
export const builds_limited_series = "Serie Limitada";
export const builds_each_build = "Cada build es una declaración única. Diseñado a la perfección. Limitado a diez.";
export const builds_view_project = "VER PROYECTO";

export const engineering_title = "Detalles de Ingeniería";
export const engineering_subtitle = "Precisión en Cada Componente";
export const engineering_tab_chassis = "Chasis";
export const engineering_tab_aero = "Aerodinámica";
export const engineering_tab_power = "Tren Motriz";
export const engineering_chassis_title = "Chasis Monocasco de Carbono";
export const engineering_chassis_desc = "Nuestro chasis monocasco de fibra de carbono propietario ofrece una rigidez excepcional manteniendo un peso mínimo. Cada capa está diseñada con precisión para una relación óptima resistencia-peso.";
export const engineering_aero_title = "Aerodinámica Activa";
export const engineering_aero_desc = "Los sistemas aerodinámicos inteligentes se adaptan en tiempo real, optimizando la carga aerodinámica y la resistencia para cada condición de conducción. Probado en túnel de viento, comprobado en pista.";
export const engineering_power_title = "Tren Motriz Híbrido";
export const engineering_power_desc = "La tecnología híbrida avanzada combina potencia bruta con eficiencia. Los motores eléctricos proporcionan par instantáneo mientras el motor de combustión ofrece rendimiento sostenido.";
export const engineering_technical_spec = "Especificación Técnica";
export const engineering_headline1 = "Diseñado con";
export const engineering_headline2 = "tolerancias exactas.";
export const engineering_body = "Cada número a continuación está medido, no estimado. Nuestro proceso se basa en metodología de grado aeroespacial aplicada a la construcción de carbono automotriz.";
export const engineering_process_overview = "Resumen del Proceso";
export const engineering_docs_note = "Documentación técnica completa disponible bajo consulta de proyecto";
export const engineering_request_docs = "Solicitar Documentación";

export const atelier_title = "Atelier de Interiores";
export const atelier_subtitle = "Artesanía a Medida";
export const atelier_desc = "Nuestro Atelier de Interiores transforma cabinas en santuarios personalizados. Cada costura, cada superficie, cada detalle está adaptado a tu visión. Desde cueros seleccionados a mano hasta tejidos de carbono personalizados, creamos interiores que reflejan tu individualidad.";
export const atelier_cta = "Diseña Tu Interior";
export const atelier_craftsmanship_label = "Artesanía";
export const atelier_headline = "INTERIOR / ATELIER";
export const atelier_body = "Donde los materiales se encuentran con la maestría. Cada costura, cada superficie, diseñada para la perfección.";
export const atelier_material_label = "MATERIAL";
export const atelier_our_services = "NUESTROS SERVICIOS";
export const atelier_schedule = "PROGRAMAR CONSULTA";

export const performance_title = "Línea Performance";
export const performance_subtitle = "Potencia Sin Compromisos";
export const performance_spec_power = "Potencia de Salida";
export const performance_spec_torque = "Par Máximo";
export const performance_spec_weight = "Peso en Vacío";
export const performance_spec_acceleration = "0-100 km/h";
export const performance_spec_top_speed = "Velocidad Máxima";
export const performance_cta = "Ver Especificaciones";
export const performance_label = "Performance";
export const performance_headline1 = "DINÁMICA";
export const performance_headline2 = "DISEÑADA";

export const models_title = "Galería de Modelos";
export const models_subtitle = "Explora Nuestra Colección";
export const models_search_placeholder = "Buscar modelos...";
export const models_filter_all = "Todos los Modelos";
export const models_filter_hypercar = "Hypercar";
export const models_filter_gt = "GT";
export const models_filter_roadster = "Roadster";
export const models_filter_limited = "Edición Limitada";
export const models_view = "Ver Detalles";
export const models_configure = "Configurar";
export const models_config_label = "Configuración · Modelos";
export const models_headline = "MODELOS / GALERÍA";
export const models_body = "Elige tu vehículo base y configúralo según tu visión. Cada proyecto se ejecuta individualmente.";
export const models_available = "modelos disponibles para configuración";
export const models_ask_another = "PREGUNTAR SOBRE OTRO MODELO";
export const models_swipe = "DESLIZA PARA EXPLORAR";

export const process_title = "Proceso de Build";
export const process_subtitle = "De la Visión a la Realidad";
export const process_step1_title = "Consulta";
export const process_step1_desc = "Comienza tu viaje con nuestro equipo de diseño. Exploraremos tu visión, preferencias y requisitos de rendimiento.";
export const process_step2_title = "Configuración";
export const process_step2_desc = "Selecciona cada detalle—desde patrones de tejido de carbono hasta materiales de interior. Visualiza tu build en tiempo real.";
export const process_step3_title = "Ingeniería";
export const process_step3_desc = "Nuestros ingenieros optimizan cada componente según tus especificaciones, asegurando máximo rendimiento y fiabilidad.";
export const process_step4_title = "Fabricación";
export const process_step4_desc = "Maestros artesanos dan vida a tu visión, construyendo a mano cada componente con precisión y cuidado.";
export const process_step5_title = "Entrega";
export const process_step5_desc = "Experimenta el momento en que tu obra maestra llega. Entrega completa y soporte de por vida incluidos.";
export const process_label = "Proceso de Build";
export const process_headline1 = "Del Carbono en Bruto";
export const process_headline2 = "al Arte Terminado.";
export const process_body = "Cada build de ORVANTHE sigue un meticuloso proceso de seis etapas. Sin atajos. Sin subcontratación. Cada vehículo es una expresión singular de precisión y artesanía.";
export const process_start_build = "Inicia Tu Build";
export const process_hours = "Horas por Build";
export const process_craftsmen = "Maestros Artesanos";
export const process_inspection = "Puntos de Inspección";
export const process_warranty = "Garantía Estructural";

export const contact_title = "Inicia Tu Build";
export const contact_subtitle = "Creemos Algo Extraordinario";
export const contact_form_name = "Nombre Completo";
export const contact_form_email = "Dirección de Correo";
export const contact_form_phone = "Número de Teléfono";
export const contact_form_interest = "Estoy Interesado En";
export const contact_form_interest_new = "Nuevo Build";
export const contact_form_interest_custom = "Proyecto Personalizado";
export const contact_form_interest_carbon = "División Carbon";
export const contact_form_interest_atelier = "Atelier de Interiores";
export const contact_form_interest_inquiry = "Consulta General";
export const contact_form_message = "Cuéntanos Sobre Tu Visión";
export const contact_form_submit = "Enviar Consulta";
export const contact_form_submitting = "Enviando...";
export const contact_form_success = "¡Gracias! Nos pondremos en contacto en 24 horas.";
export const contact_form_error = "Algo salió mal. Por favor, inténtalo de nuevo.";
export const contact_form_required = "Este campo es obligatorio";
export const contact_form_email_invalid = "Por favor, introduce una dirección de correo válida";
export const contact_configure_label = "Configurar";
export const contact_headline1 = "INICIA TU";
export const contact_headline2 = "BUILD";
export const contact_body = "Selecciona tu paquete, elige tu vehículo, y crearemos algo irrepetible.";
export const contact_step_package = "Paquete";
export const contact_step_vehicle = "Vehículo";
export const contact_step_details = "Detalles";
export const contact_continue = "Continuar";
export const contact_back = "Atrás";
export const contact_edit = "Editar";
export const contact_change = "Cambiar";
export const contact_select_brand = "Seleccionar Marca *";
export const contact_select_model = "Seleccionar Modelo *";
export const contact_enter_vehicle = "Ingresa Tu Vehículo *";
export const contact_timeline_label = "Plazo Preferido";
export const contact_timeline_placeholder = "Seleccionar plazo";
export const contact_timeline_asap = "Lo antes posible";
export const contact_timeline_1_3 = "1–3 meses";
export const contact_timeline_3_6 = "3–6 meses";
export const contact_timeline_6_12 = "6–12 meses";
export const contact_timeline_exploring = "Solo explorando opciones";
export const contact_additional_details = "Detalles Adicionales";
export const contact_message_placeholder = "Cuéntanos sobre tu visión — preferencias de color, modificaciones específicas, inspiración...";
export const contact_submit_inquiry = "Enviar Consulta";
export const contact_processing = "Procesando...";
export const contact_success = "¡Gracias! Te contactaremos en 24 horas para hablar sobre tu build.";
export const contact_error = "Por favor completa todos los campos requeridos e inténtalo de nuevo.";
export const contact_location = "Varsovia, PL";

export const news_title = "Últimas Noticias";
export const news_subtitle = "Actualizaciones de Veragua";
export const news_read_more = "Leer Más";

export const social_title = "Sigue Nuestro Viaje";
export const social_subtitle = "Detrás de Escena";
export const social_view_post = "Ver Publicación";

export const footer_tagline = "Excelencia en Ingeniería. Rendimiento Sin Compromisos.";
export const footer_company = "Empresa";
export const footer_company_about = "Acerca de";
export const footer_company_careers = "Carreras";
export const footer_company_press = "Prensa";
export const footer_company_contact = "Contacto";
export const footer_models = "Modelos";
export const footer_models_hypercar = "Serie Hypercar";
export const footer_models_gt = "Colección GT";
export const footer_models_roadster = "Línea Roadster";
export const footer_models_limited = "Ediciones Limitadas";
export const footer_services = "Servicios";
export const footer_services_carbon = "División Carbon";
export const footer_services_atelier = "Atelier de Interiores";
export const footer_services_bespoke = "Proyectos a Medida";
export const footer_services_support = "Soporte al Propietario";
export const footer_legal = "Legal";
export const footer_legal_privacy = "Política de Privacidad";
export const footer_legal_terms = "Términos de Servicio";
export const footer_legal_cookies = "Política de Cookies";
export const footer_copyright = "© 2024 Veragua. Todos los derechos reservados.";
export const footer_powered = "Creador de Sitios Web";
export const footer_copyright_text = "© ORVANTHE 2025. TODOS LOS DERECHOS RESERVADOS.";
export const footer_tagline_short = "Fabricado en Carbono. Construido Sin Compromisos.";

export const about_hero_title = "Acerca de Veragua";
export const about_hero_subtitle = "Diseñando el Futuro del Rendimiento";
export const about_story_title = "Nuestra Historia";
export const about_story_text = "Fundada sobre el principio de que el compromiso no tiene lugar en la excelencia automotriz, Veragua surgió de una visión para redefinir lo posible. No construimos autos—diseñamos experiencias que trascienden los límites convencionales.";
export const about_philosophy_title = "Nuestra Filosofía";
export const about_philosophy_text = "Cada decisión, cada componente, cada detalle está guiado por un compromiso inquebrantable con la perfección. Creemos en la pureza del propósito, la elegancia de la ingeniería y la búsqueda incesante del rendimiento.";
export const about_craftsmanship_title = "Artesanía";
export const about_craftsmanship_text = "Nuestros maestros artesanos combinan técnicas tradicionales con tecnología de vanguardia. Cada vehículo se construye a mano, asegurando que cada superficie, cada costura, cada componente cumpla con nuestros exigentes estándares.";
export const about_vision_title = "Nuestra Visión";
export const about_vision_text = "Imaginamos un futuro donde el rendimiento y la sostenibilidad coexisten, donde la tecnología mejora la experiencia de conducción sin disminuirla, y donde cada viaje es una expresión del arte automotriz.";
export const about_hero_subtitle_short = "Donde la ingeniería de precisión se encuentra con la visión artística";
export const about_hero_scroll = "DESPLAZAR";
export const about_story_heading = "Los Comienzos";
export const about_story_p1 = "Fundada en 2018, ORVANTHE surgió de una visión singular: trascender los límites entre la ingeniería automotriz y las bellas artes. Lo que comenzó como un proyecto de pasión en un modesto taller ha evolucionado hasta convertirse en un atelier de excelencia automotriz reconocido mundialmente.";
export const about_story_p2 = "Nuestro fundador, impulsado por una obsesión con la perfección y un profundo respeto por el patrimonio automotriz, reunió un equipo de maestros artesanos, ingenieros y diseñadores que compartían los mismos estándares intransigentes. Juntos, inauguraron un nuevo enfoque para la personalización automotriz.";
export const about_story_p3 = "Cada creación ORVANTHE nace de cientos de horas de planificación meticulosa, escaneo 3D y acabado a mano. No simplemente modificamos vehículos; los reconstruimos a nivel molecular, reimaginando lo que es posible cuando el arte se encuentra con la precisión de la ingeniería.";
export const about_story_est = "Fund. 2018";
export const about_story_since = "PRECISIÓN DESDE EL PRIMER DÍA";

export const about_craft_heading = "En Números";
export const about_craft_body = "Precisión, dedicación y excelencia medidas";
export const about_craft_quote = "No construimos autos. Esculpimos sueños de carbono y acero, creando poesía de ingeniería que se mueve a 320 km/h.";
export const about_craft_manifesto = "MANIFIESTO ORVANTHE";
export const about_craft_stat1_label = "Horas por Build";
export const about_craft_stat1_desc = "Atención meticulosa a cada detalle";
export const about_craft_stat2_label = "Maestros Artesanos";
export const about_craft_stat2_desc = "Décadas de experiencia combinada";
export const about_craft_stat3_label = "Tolerancia de Precisión";
export const about_craft_stat3_desc = "Ingeniería a nivel microscópico";
export const about_craft_stat4_label = "Acabado a Mano";
export const about_craft_stat4_desc = "Sin atajos, sin compromisos";

export const about_phil_heading = "Nuestra Filosofía";
export const about_phil_body = "Cuatro principios que guían cada decisión, cada diseño, cada detalle";
export const about_phil_p1_title = "Visión Sin Compromisos";
export const about_phil_p1_desc = "Nos negamos a aceptar limitaciones. Cada proyecto comienza con una pregunta: ¿y si pudiéramos hacerlo mejor? Esta búsqueda incesante de perfección impulsa cada decisión, cada medición, cada acabado.";
export const about_phil_p2_title = "Artesanía de Maestro";
export const about_phil_p2_desc = "En una era de automatización, defendemos el toque humano. Nuestros maestros artesanos pasan años perfeccionando sus habilidades, asegurando que cada superficie, cada costura, cada detalle refleje los más altos estándares de calidad.";
export const about_phil_p3_title = "Innovación Sin Compromisos";
export const about_phil_p3_desc = "Adoptamos tecnología de vanguardia — escaneo 3D, ingeniería de fibra de carbono, aerodinámica avanzada — pero nunca a expensas del alma. La tecnología sirve al arte, no al revés.";
export const about_phil_p4_title = "Asociación con el Cliente";
export const about_phil_p4_desc = "Cada creación ORVANTHE es una colaboración. Escuchamos, asesoramos, refinamos. Tu visión se convierte en nuestra misión, y juntos creamos algo que trasciende las expectativas.";

export const about_vision_heading = "Mirando hacia el Futuro";
export const about_vision_p1 = "El futuro de ORVANTHE no se trata de volumen — se trata de impacto. Nunca comprometeremos nuestros estándares para escalar la producción. En cambio, invertimos en materiales de próxima generación, aerodinámica avanzada y prácticas de ingeniería sostenibles.";
export const about_vision_p2 = "Nuestra visión se extiende más allá de los builds individuales. Estamos creando un legado de innovación, formando a la próxima generación de maestros artesanos y empujando los límites de lo posible cuando el arte y la ingeniería convergen.";
export const about_vision_p3 = "Cada vehículo ORVANTHE es una declaración: que la excelencia no puede apresurarse, que la belleza requiere paciencia, y que el verdadero lujo se mide no en precio, sino en la búsqueda de la perfección.";
export const about_vision_sustain_title = "Innovación Sostenible";
export const about_vision_sustain_desc = "Fabricación neutra en carbono para 2026";
export const about_vision_academy_title = "Academia de Artesanos";
export const about_vision_academy_desc = "Formando a la próxima generación de artesanos";
export const about_vision_materials_title = "Materiales del Futuro";
export const about_vision_materials_desc = "Pioneros en compuestos de grado aeroespacial";
export const about_vision_statement = "Esto no es estilismo. Esto es reconstrucción.";

export const back_to_top = "Volver arriba";

export const common = {
  nav: {
    carbon: 'CARBON',
    builds: 'PROYECTOS',
    atelier: 'ATELIER',
    performance: 'PERFORMANCE',
  },
  contact: {
    hero: {
      eyebrow: 'Ponte en contacto',
      title: 'Contacto',
      subtitle: 'Contáctanos para discutir tu visión, programar una visita al estudio o consultar sobre nuestros servicios.'
    },
    info: {
      title: 'Información del Estudio',
      address: {
        label: 'Dirección',
        value: 'Aleje Jerozolimskie 123',
        subvalue: '00-001 Varsovia, Polonia'
      },
      email: {
        label: 'Email',
      },
      phone: {
        label: 'Teléfono',
      },
      hours: {
        label: 'Horario del Estudio',
        value: 'Lunes – Viernes: 9:00 – 18:00',
        subvalue: 'Sábado: Solo con cita previa'
      },
      social: 'Síguenos'
    },
    visit: {
      title: 'Programa una visita al estudio',
      description: 'Experimenta ORVANTHE en persona. Recorre nuestras instalaciones, conoce a nuestro equipo y explora nuestra biblioteca de materiales y proyectos completados.',
      benefit1: 'Consulta privada con nuestro equipo de diseño',
      benefit2: 'Selección práctica de materiales y acabados',
      benefit3: 'Ver proyectos actuales en progreso',
      cta: 'Reserva tu visita',
      form: {
        title: 'Reserva tu visita al estudio',
        subtitle: 'Selecciona tu fecha y hora preferidas. Confirmaremos la disponibilidad en 24 horas.',
        name: 'Nombre completo',
        email: 'Dirección de email',
        phone: 'Número de teléfono',
        date: 'Fecha preferida',
        time: 'Hora preferida',
        visitors: 'Número de visitantes',
        selectTime: 'Seleccionar hora',
        notes: 'Notas adicionales',
        notesPlaceholder: '¿Algún interés o pregunta específica?',
        submit: 'Confirmar reserva',
        submitting: 'Enviando...',
        validation: 'Por favor, completa todos los campos obligatorios.',
        success: {
          title: 'Visita programada',
          message: 'Tu visita al estudio ha sido confirmada. Te enviaremos un email de confirmación en breve.'
        }
      }
    },
    form: {
      title: 'Envíanos un mensaje',
      subtitle: 'Normalmente respondemos en 24 horas.',
      name: 'Nombre completo',
      namePlaceholder: 'Juan García',
      email: 'Dirección de email',
      emailPlaceholder: 'juan@ejemplo.com',
      phone: 'Número de teléfono',
      phonePlaceholder: '+34 123 456 789',
      subject: 'Asunto',
      subjectPlaceholder: 'Selecciona un asunto',
      subjects: {
        general: 'Consulta general',
        carbon: 'División Carbon',
        atelier: 'Atelier de Interiores',
        performance: 'Línea Performance',
        build: 'Solicitud de proyecto personalizado',
        partnership: 'Oportunidad de asociación'
      },
      message: 'Mensaje',
      messagePlaceholder: 'Cuéntanos sobre tu proyecto o consulta...',
      characters: 'caracteres',
      submit: 'Enviar mensaje',
      sending: 'Enviando...',
      validation: 'Por favor, completa todos los campos obligatorios.',
      maxLength: 'El mensaje no puede exceder 500 caracteres.',
      success: {
        title: 'Mensaje enviado',
        message: 'Gracias por contactarnos. Hemos recibido tu mensaje.',
        response: 'Nuestro equipo responderá en 24 horas.'
      }
    },
    map: {
      title: 'Encuentra nuestro estudio',
      subtitle: 'Ubicado en el corazón de Varsovia',
      location: 'Ubicación del estudio'
    },
    faq: {
      title: 'Preguntas frecuentes',
      subtitle: 'Respuestas rápidas a consultas comunes',
      q1: {
        question: '¿Cuál es el tiempo típico para un proyecto personalizado?',
        answer: 'La mayoría de los proyectos toman de 8 a 16 semanas desde la consulta inicial hasta la entrega, dependiendo de la complejidad y disponibilidad de materiales. Servicios express están disponibles para paquetes seleccionados.'
      },
      q2: {
        question: '¿Envían internacionalmente?',
        answer: 'Sí, enviamos a todo el mundo. Todos los componentes de carbono están cuidadosamente empaquetados y asegurados. El soporte de instalación puede organizarse a través de nuestra red de socios.'
      },
      q3: {
        question: '¿Puedo visitar el estudio sin cita previa?',
        answer: 'Recomendamos programar una visita con anticipación para asegurar que nuestro equipo esté disponible para brindarte un recorrido y consulta completos.'
      },
      q4: {
        question: '¿Qué métodos de pago aceptan?',
        answer: 'Aceptamos transferencias bancarias, tarjetas de crédito y criptomonedas. Se requiere un depósito del 50% para comenzar el trabajo, con el saldo debido al completarse.'
      },
      q5: {
        question: '¿Ofrecen servicios de instalación?',
        answer: 'Sí, la instalación profesional está disponible en nuestro estudio o a través de nuestra red de socios certificados en Europa y más allá.'
      },
      q6: {
        question: '¿Qué garantía proporcionan?',
        answer: 'Todos los productos ORVANTHE vienen con una garantía de 2 años que cubre defectos de fabricación. Los componentes de carbono incluyen una garantía estructural de por vida.'
      },
      more: '¿Todavía tienes preguntas?',
      email: 'Envíanos un email directamente'
    }
  }
};
